export default {
  companyUrl: 'https://dev.lwtears.com',
  pliUrl: 'https://qa01-pli.lwtears.com',
  digitalProductSupportUrl: 'https://dev.lwtears.com/contact-us/digital-product-support',
  digitalAssetsUrl: 'https://a-z-educator-content-qa.s3.amazonaws.com',
};
